import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { IconAlertCircle, IconRefresh } from '@tabler/icons-react'

interface DashboardErrorProps {
  message: string
  onRetry: () => void
}

export function DashboardError({ message, onRetry }: DashboardErrorProps) {
  return (
    <div className='space-y-4'>
      <div className='grid gap-4 sm:grid-cols-2 lg:grid-cols-4'>
        {Array.from({ length: 4 }).map((_, index) => (
          <Card
            key={index}
            className='border-destructive bg-destructive/5'
          >
            <CardHeader className='flex flex-row items-center justify-between space-y-0 pb-2'>
              <CardTitle className='text-sm font-medium text-destructive'>
                Erro ao carregar
              </CardTitle>
              <IconAlertCircle className='h-4 w-4 text-destructive' />
            </CardHeader>
            <CardContent>
              <div className='text-2xl font-bold text-destructive'>--</div>
              <p className='text-xs text-muted-foreground'>
                Dados indisponíveis
              </p>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card className='border-destructive bg-destructive/5'>
        <CardContent className='flex flex-col items-center justify-center py-12'>
          <IconAlertCircle className='mb-4 h-12 w-12 text-destructive' />
          <h3 className='mb-2 text-lg font-semibold text-destructive'>
            Erro ao carregar dashboard
          </h3>
          <p className='mb-4 text-sm text-muted-foreground'>{message}</p>
          <Button variant='default' onClick={onRetry}>
            <IconRefresh className='mr-2 h-4 w-4' />
            Tentar novamente
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
